/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Component, HostBinding, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SortMeta } from 'primeng/api';
import { Select, SelectModule } from 'primeng/select';

@Component({
  selector: 'shared-ui-sort-control',
  templateUrl: './sort-control.component.html',
  standalone: true,
  imports: [CommonModule, SelectModule, FormsModule, Select],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: SortControlComponent,
      multi: true,
    }
  ],
})
export class SortControlComponent implements ControlValueAccessor {
  @Input() sortModels: { field: string; label: string }[] = [
    {
      field: 'createdAt',
      label: 'Data primirii',
    },
    {
      field: 'offerRequestDeadline',
      label: 'Deadline',
    }
  ];

  @HostBinding('class.p-inputwrapper-focus') readonly focus = false;
  @HostBinding('class.p-inputwrapper-filled') readonly filled = false;

  disabled = false;
  sortMeta = {
    field: { field: '', label: '' },
    order: 1,
  };
  private onDataChange: any | undefined = undefined;
  private onTouched: any | undefined = undefined;

  sortChange() {
    if (this.sortMeta.order === 1) {
      this.sortMeta.order = -1;
    } else {
      this.sortMeta.order = 1;
    }

    this.emitNewValue();
  }

  emitNewValue() {
    const sortObject = {
      field: this.sortMeta.field.field,
      order: this.sortMeta.order,
    };
    if (this.onDataChange && sortObject.field) {
      this.onDataChange(sortObject);
    }
  }

  registerOnChange(fn: any): void {
    this.onDataChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  writeValue(obj: SortMeta | null | undefined): void {
    if (obj) {
      const field = this.sortModels.find((item) => item.field === obj.field);
      if(field) {
        this.sortMeta = {
          field: field,
          order: obj.order,
        };
      }
    } else {
      this.sortMeta.field = this.sortModels[0];
      this.sortMeta.order = 1;
    }
  }

  sortFieldChange(event: { value: { field: string; label: string } }) {
    this.sortMeta.field = event ? event.value : this.sortMeta.field;
    this.emitNewValue();
  }
}
